import { ReactNode } from "react";
import { cn } from "@/lib/utils";

interface QuestionnaireFormSectionProps {
  title?: ReactNode;
  children: ReactNode;
  className?: string;
}

export function QuestionnaireFormSection({
  title,
  children,
  className,
}: QuestionnaireFormSectionProps) {
  return (
    <section className={cn("space-y-4", className)}>
      {title && (
        <h3 className="text-lg font-semibold text-slate-900">{title}</h3>
      )}
      <div className="space-y-4">{children}</div>
    </section>
  );
}
